import { render, staticRenderFns } from "./mahjongPhoenix.vue?vue&type=template&id=b09c99e8&scoped=true"
import script from "./mahjongPhoenix.vue?vue&type=script&lang=js"
export * from "./mahjongPhoenix.vue?vue&type=script&lang=js"
import style0 from "./mahjongPhoenix.vue?vue&type=style&index=0&id=b09c99e8&prod&scoped=true&lang=css"
import style1 from "./mahjongPhoenix.vue?vue&type=style&index=1&id=b09c99e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09c99e8",
  null
  
)

export default component.exports